import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

import dayjs from 'dayjs';

import { IAuthDTO } from '../api/models/v1/auth';

@Injectable({
    providedIn: 'root',
})
export class LocalStorageService {
    public auth!: AuthLocalStorage;
    public redirect!: RedirectLocalStorage;
    public register!: RegisterLocalStorage;
    public tour!: TourLocalStorage;

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        this.auth = new AuthLocalStorage(this.platformId);
        this.redirect = new RedirectLocalStorage(this.platformId);
        this.register = new RegisterLocalStorage(this.platformId);
        this.tour = new TourLocalStorage(this.platformId);
    }
}

export class AuthLocalStorage {
    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    }

    public get(): IAuthDTO | null {
        if (isPlatformBrowser(this.platformId)) {
            return {
                token: localStorage.getItem('LoginToken') ?? '',
                isFirstTime: localStorage.getItem('LoginFirstTime') == '1',
                expiresDateTime: localStorage.getItem('LoginExpireDate') ? dayjs(localStorage.getItem('LoginExpireDate')).toDate() : new Date()
            };
        }

        return null;
    }

    public set(value: IAuthDTO): void {
        if (isPlatformBrowser(this.platformId)) {
            if (value.token) localStorage.setItem('LoginToken', value.token);
            if (value.expiresDateTime) localStorage.setItem('LoginExpireDate', dayjs(value.expiresDateTime).format('YYYY-MM-DDTHH:mm:ss'));

            localStorage.setItem('LoginFirstTime', value.isFirstTime ? '1' : '0');
        }
    }

    public clear(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('LoginToken');
            localStorage.removeItem('LoginExpireDate');
            localStorage.removeItem('LoginFirstTime');
        }
    }
}

export class RedirectLocalStorage {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    }

    public get(): string | null {
        if (isPlatformBrowser(this.platformId)) {
            return localStorage.getItem('Redirect');
        }
        return null;
    }

    public set(value: string): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('Redirect', value);
        }
    }

    public clear(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('Redirect');
        }
    }
}

export class RegisterLocalStorage {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    }

    public get(): { isFirstTime: boolean } {
        if (isPlatformBrowser(this.platformId)) {
            const value = localStorage.getItem('Register');

            if (value) {
                return JSON.parse(value);
            }
        }
        return {
            isFirstTime: false
        };
    }

    public set(value:  { isFirstTime: boolean }): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.setItem('Register', JSON.stringify(value));
        }
    }

    public clear(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('Register');
        }
    }
}

export class TourLocalStorage {

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    }

    public get(): boolean {
        if (isPlatformBrowser(this.platformId)) {
            const value = localStorage.getItem('Tour');

            return value != null;
        }
        return false;
    }

    public set(value: boolean | null): void {
        if (isPlatformBrowser(this.platformId)) {
            if (value == null) {
                this.clear();
            } else {
                localStorage.setItem('Tour', `${value}`);
            }
        }
    }

    public clear(): void {
        if (isPlatformBrowser(this.platformId)) {
            localStorage.removeItem('Tour');
        }
    }
}


